import { Parallax } from 'react-parallax';
import JGD from '../img/jgd.webp'

const ImageTwo = () => (
    <Parallax className='image' blur={0} bgImage={JGD} strength={800} bgImageStyle={{}}>
    </Parallax>
);

export default ImageTwo